import { createApp } from "vue";

import App from './App.vue';
// import App from './components/authentication/ForgotPassword.vue';
// import App from './components/journal/JournalPage.vue'
// import App from './components/workbook/WorkbookPage.vue';

// import App from "./components/my-progress/MyProgressPage.vue";

import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import "vuetify/styles";
import { aliases, mdi } from "vuetify/iconsets/mdi";

import "@mdi/font/css/materialdesignicons.css";
import "vuetify/dist/vuetify.min.css";
import router from "./router/index.js";
import axios from "axios";

const brandingColors = {
  dark: false,
  colors: {
    "aqua-teal": "#08B6AA",
  },
};
const vuetify = createVuetify({
  components,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: "brandingColors",
    themes: {
      brandingColors,
    },
  },
});

console.log(process.env.VUE_APP_API_URL);
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

const app = createApp(App);
app.config.warnHandler = () => {}; // Ignore warnings

app.use(vuetify).use(router);
app.mount("#app");
